// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1YyuP","dragIcon":"SortableItem_dragIcon__1J58K","disabled":"SortableItem_disabled__2A9Ln"};